import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { LanguageProvider } from './contexts/LanguageContext';
import { SettingsProvider } from './contexts/SettingsContext';

// Landing Page Components
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Packages from './components/Packages';
import HowItWorks from './components/HowItWorks';
import Contact from './components/Contact';
import Footer from './components/Footer';

// Admin Components
import AdminLogin from './components/AdminLogin';
import AdminLayout from './components/AdminLayout';
import AdminDashboard from './components/AdminDashboard';
import AdminServices from './components/AdminServices';
import AdminPackages from './components/AdminPackages';
import AdminSettings from './components/AdminSettings';
import DocumentTitle from './components/DocumentTitle';
import PayrollDashboard from './components/PayrollDashboard';

import './App.css';

// Landing Page
const LandingPage = () => {
  return (
    <>
      <Navbar />
      <Hero />
      <Services />
      <Packages />
      <HowItWorks />
      <Contact />
      <Footer />
    </>
  );
};

// Admin Pages with Layout
const AdminDashboardPage = () => (
  <AdminLayout>
    <AdminDashboard />
  </AdminLayout>
);

const AdminServicesPage = () => (
  <AdminLayout>
    <AdminServices />
  </AdminLayout>
);

const AdminPackagesPage = () => (
  <AdminLayout>
    <AdminPackages />
  </AdminLayout>
);

const AdminSettingsPage = () => (
  <AdminLayout>
    <AdminSettings />
  </AdminLayout>
);

const AdminPayrollPage = () => (
  <AdminLayout>
    <PayrollDashboard />
  </AdminLayout>
);

function App() {
  return (
    <LanguageProvider>
      <SettingsProvider>
        <DocumentTitle />
        <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<LandingPage />} />
          
          {/* Admin Routes */}
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
          <Route path="/admin/services" element={<AdminServicesPage />} />
          <Route path="/admin/packages" element={<AdminPackagesPage />} />
          <Route path="/admin/settings" element={<AdminSettingsPage />} />
          <Route path="/admin/payroll" element={<AdminPayrollPage />} />
        </Routes>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
      </SettingsProvider>
    </LanguageProvider>
  );
}

export default App;
